import { TextField, useTheme } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

const ProfileTitle = ({ errors, data, register }) => {
  const theme = useTheme();
  const { t } = useTranslation('global');
  return (
    <TextField
      fullWidth
      helperText={errors?.title?.message}
      FormHelperTextProps={{
        style: { margin: 0, color: theme.palette.error.main },
        'data-testid': 'helpertext-profile-job-title',
      }}
      inputProps={{
        'data-testid': 'profile-job-title',
        maxLength: 31,
      }}
      defaultValue={data?.title}
      error={!!errors.title}
      label={t('modalProfile.jobTitle')}
      size="small"
      {...register('title', {
        maxLength: {
          value: t('modalProfile.validation.jobTitle.value'),
          message: t('modalProfile.validation.jobTitle.message', {
            limit: t('modalProfile.validation.jobTitle.value'),
          }),
        },
      })}
    />
  );
};

export default ProfileTitle;
